// src/sot/primitives/ListItem48.jsx
import React from "react";

/**
 * ListItem48
 * - default: rounded tile w/ outline behaviour
 * - bare: ZERO chrome (no bg, no border, no padding)
 *   ➜ Used when wrapped inside another card (Notifications)
 */
export default function ListItem48({
  icon = null,
  title,
  subtitle,
  isActive = false,
  onClick,
  titleClass = "text-body-large text-on-surface",
  subtitleClass = "text-body-medium text-on-surface-var",
  variant = "default",
  className = "",
}) {
  const isBare = variant === "bare";

  // --------------------------------------------
  // OUTER CONTAINER CLASSES
  // --------------------------------------------
  const outerClasses = [
    "w-full text-left transition-colors",
    isBare
      ? [
          // ♦ BARE MODE — remove ALL chrome
          "bg-transparent",
          "px-0 py-0",
          "rounded-none",
          "border-none",
          "outline-none",
          "appearance-none",
          "shadow-none",
          "focus-visible:outline-none focus-visible:ring-0",
        ].join(" ")
      : [
          // ♦ DEFAULT MODE
          "rounded-2xl px-4 py-3",
          "bg-[var(--Schemes-Surface,#FFFFFF)] shadow-[var(--elev-1)]",
          isActive ? "ring-1 ring-[rgba(var(--afrimed-primary),0.16)]" : "",
        ].join(" "),
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // --------------------------------------------
  // ICON RENDERING
  // --------------------------------------------
  const renderIcon = () => {
    if (!icon) {
      return (
        <div className="w-6 h-6 rounded bg-[rgba(91,107,134,0.12)]" />
      );
    }
    if (typeof icon === "string") {
      return <img src={icon} alt="" className="w-6 h-6" />;
    }
    return (
      <span className="w-6 h-6 flex items-center justify-center">
        {icon}
      </span>
    );
  };

  // --------------------------------------------
  // RENDER
  // --------------------------------------------
  return (
    <button type="button" onClick={onClick} className={outerClasses}>
      <div className="flex items-start gap-3">
        {renderIcon()}

        <div className="flex-1 min-w-0">
          <div className={titleClass}>{title}</div>
          {subtitle && (
            <div className={`${subtitleClass} mt-1`}>
              {subtitle}
            </div>
          )}
        </div>

        {/* Chevron */}
        <span
          className="text-[20px] text-on-surface-var select-none"
          aria-hidden="true"
        >
          ›
        </span>
      </div>
    </button>
  );
}
